import * as React from 'react';
import { useState } from "react";
import axios from 'axios';

// Relative paths like /images/home/Review/x.webp live on the website, not the portal
export const imgSrc = (img) => {
  if (!img) return ''
  if (/^https?:\/\//i.test(img)) return img
  return 'https://tawaftravel.co.uk' + (img.startsWith('/') ? '' : '/') + img
}

export const Stars = ({ value, onChange, size = '1.6rem' }) => (
  <span style={{ whiteSpace: 'nowrap' }}>
    {[1, 2, 3, 4, 5].map((n) => (
      <span
        key={n}
        role={onChange ? 'button' : undefined}
        title={onChange ? n + ' star' : undefined}
        onClick={onChange ? () => onChange(n) : undefined}
        style={{
          fontSize: size, lineHeight: 1, cursor: onChange ? 'pointer' : 'default',
          color: n <= Number(value) ? '#E3A72F' : '#d0d5da'
        }}
      >★</span>
    ))}
  </span>
)

// Shared fields for Add / Update review
export default function ReviewForm({ name, setName, review, setReview, img, setImg, rating, setRating, sort, setSort, status, setStatus }) {
  const [uploading, setUploading] = useState(false)

  const uploadImg = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const data = new FormData();
    data.append('file', file);
    setUploading(true)
    axios({
      method: 'post',
      url: '/api/review/upload.php',
      data: data,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(s => {
        if (s.data[0].msg === "pass") {
          setImg(s.data[0].url)
        } else {
          alert(s.data[0].error || "Image upload nahi hui.")
        }
      })
      .catch(s => {
        console.log('here catch =>>', s);
        alert("Image upload nahi hui.")
      })
      .finally(() => {
        setUploading(false)
        event.target.value = '';
      });
  };

  return (
    <>
      <div className="col-lg-6 mb-3 fw-bold">
        <label className="form-label">Name</label>
        <input type="text" className="form-control" autoComplete="off"
          value={name} onChange={(v) => setName(v.target.value)} />
      </div>
      <div className="col-lg-3 mb-3 fw-bold">
        <label className="form-label">Sort Order (chhota number pehle)</label>
        <input type="number" className="form-control"
          value={sort} onChange={(v) => setSort(v.target.value)} />
      </div>
      <div className="col-lg-3 mb-3 fw-bold">
        <label className="form-label">Status</label>
        <select className="form-control" value={status} onChange={(v) => setStatus(v.target.value)}>
          <option value="1">Active</option>
          <option value="0">Inactive</option>
        </select>
      </div>
      <div className="col-lg-12 mb-3 fw-bold">
        <label className="form-label d-block">Rating</label>
        <Stars value={rating} onChange={setRating} />
        <span className="ms-2 text-muted fw-normal">{rating} / 5</span>
      </div>
      <div className="col-lg-12 mb-3 fw-bold">
        <label className="form-label">Description (Review)</label>
        <textarea className="form-control" rows="5"
          value={review} onChange={(v) => setReview(v.target.value)}></textarea>
      </div>
      <div className="col-lg-12 mb-3 fw-bold">
        <label className="form-label">Image</label>
        <div className="d-flex align-items-start flex-wrap" style={{ gap: '16px' }}>
          <div style={{
            width: '80px', height: '80px', borderRadius: '50%', overflow: 'hidden',
            background: '#f1f3f5', border: '1px solid #e9ecef', flexShrink: 0,
            display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}>
            {img
              ? <img src={imgSrc(img)} alt="preview" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              : <small className="text-muted fw-normal">No image</small>}
          </div>
          <div style={{ flex: 1, minWidth: '240px' }}>
            <input type="file" accept=".jpg,.jpeg,.png,.webp" className="form-control mb-2"
              disabled={uploading} onChange={uploadImg} />
            <small className="text-muted fw-normal d-block mb-2">
              {uploading ? 'Uploading...' : 'JPG, PNG ya WEBP (max 2MB) — ya neeche image ka URL / path likhein.'}
            </small>
            <input type="text" className="form-control" autoComplete="off" placeholder="/images/home/Review/review_1.webp"
              value={img} onChange={(v) => setImg(v.target.value)} />
          </div>
        </div>
      </div>
    </>
  )
}
